<template>
  <footer>
    <div class="mt-8 bg-[#313131] pt-9">
      <div class="mx-auto w-full max-w-[1166px] px-4 xl:px-0">
        <div class="flex flex-col justify-between sm:px-[18px] md:flex-row md:px-10">
          <!-- Logo & Description Section -->
          <div class="md:w-[316px] max-sm:text-center" :class="{ 'text-right': $i18n.locale === 'ar' }">
            <div class="text-[18px] font-medium text-white">
              <h1 class="text-white font-extrabold">
                <img src="@/assets/logo.png" alt="MTS GPS"
                  class="h-10 md:h-9 transition-all duration-300 hover:scale-105 max-sm:mx-auto"
                  :class="{ 'mx-auto md:ml-auto md:mr-0': $i18n.locale === 'ar' }">
              </h1>
            </div>
            <p class="mt-[18px] text-[15px] font-normal text-white/[80%] max-sm:text-center">
              {{ $t('footer.description') }}
            </p>
            <div class="mt-[18px] flex gap-4 max-sm:justify-center"
              :class="[$i18n.locale === 'ar' ? 'flex-row-reverse justify-end' : '']">
              <a class="hover:scale-110" target="_blank" href="mailto:marwan@mts.sy">
                <img alt="email icon" loading="lazy" width="36" height="36"
                  src="https://img.icons8.com/?size=100&id=12580&format=png&color=FFFFFF" />
              </a>
              <a class="hover:scale-110" target="_blank" href="https://www.instagram.com/mts_gps/">
                <img alt="instagram icon" loading="lazy" width="36" height="36"
                  src="https://img.icons8.com/ios7/600/FFFFFF/instagram-new.png" />
              </a>
              <a class="hover:scale-110" target="_blank" href="https://www.facebook.com/mtsgps1">
                <img alt="facebook icon" loading="lazy" width="36" height="36"
                  src="https://img.icons8.com/ios7/600/FFFFFF/facebook-new.png" />
              </a>
            </div>
          </div>

          <!-- Contact Info Section -->
          <div class="md:w-[316px] max-sm:text-center" :class="{ 'text-right': $i18n.locale === 'ar' }">
            <!-- WhatsApp -->
            <div class="mt-[23px] flex contact-info max-sm:flex-col max-sm:items-center"
              :class="{ 'flex-row-reverse': $i18n.locale === 'ar' }">
              <div
                :class="[$i18n.locale === 'ar' ? 'ml-[18px]' : 'ml-[18px]', 'order-1', { 'order-none': $i18n.locale === 'ar' }, 'w-full']">
                <a href="https://api.whatsapp.com/send?phone=963987292450"
                  class="font-Inter text-[14px] font-medium text-[#26c561] ltr block max-sm:text-center">
                  +963 987 292 450
                </a>
                <p class="font-Inter text-[12px] font-medium text-white max-sm:text-center">{{
                  $t('footer.supportNumber') }}</p>
              </div>
              <div class="flex h-[38px] w-[38px] items-center justify-center rounded-[75%] max-sm:mb-2"
                :class="{ 'order-1': $i18n.locale === 'ar' }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20.8472 14.8554L16.4306 12.8764L16.4184 12.8707C16.1892 12.7727 15.939 12.7333 15.6907 12.7562C15.4424 12.7792 15.2037 12.8636 14.9963 13.002C14.9718 13.0181 14.9484 13.0357 14.9259 13.0545L12.6441 14.9998C11.1984 14.2976 9.70595 12.8164 9.00376 11.3895L10.9519 9.07294C10.9706 9.0495 10.9884 9.02606 11.0053 9.00075C11.1407 8.79384 11.2229 8.55667 11.2445 8.31035C11.2661 8.06402 11.2264 7.81618 11.1291 7.58887V7.57762L9.14438 3.15356C9.0157 2.85662 8.79444 2.60926 8.51362 2.44841C8.2328 2.28756 7.9075 2.22184 7.58626 2.26106C6.31592 2.42822 5.14986 3.05209 4.30588 4.01615C3.4619 4.98021 2.99771 6.21852 3.00001 7.49981C3.00001 14.9436 9.05626 20.9998 16.5 20.9998C17.7813 21.0021 19.0196 20.5379 19.9837 19.6939C20.9477 18.85 21.5716 17.6839 21.7388 16.4136C21.7781 16.0924 21.7125 15.7672 21.5518 15.4864C21.3911 15.2056 21.144 14.9843 20.8472 14.8554Z"
                    fill="white"></path>
                </svg>
              </div>
            </div>

            <!-- Email -->
            <div class="mt-[23px] flex contact-info max-sm:flex-col max-sm:items-center"
              :class="{ 'flex-row-reverse': $i18n.locale === 'ar' }">
              <div
                :class="[$i18n.locale === 'ar' ? 'ml-[18px]' : 'ml-[18px]', 'order-1', { 'order-none': $i18n.locale === 'ar' }, 'w-full']">
                <a href="mailto:marwan@mts.sy"
                  class="font-Inter text-[14px] font-medium text-[#26c561] ltr block max-sm:text-center">
                  marwan@mts.sy
                </a>
                <p class="font-Inter text-[12px] font-medium text-white max-sm:text-center">{{ $t('footer.supportEmail')
                }}</p>
              </div>
              <div class="flex h-[38px] w-[38px] items-center justify-center rounded-[75%] max-sm:mb-2"
                :class="{ 'order-1': $i18n.locale === 'ar' }">
                <svg fill="white" width="25" height="25" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M64 128Q64 113 73 105 81 96 96 96L416 96Q431 96 440 105 448 113 448 128L448 144 256 272 64 144 64 128ZM256 328L448 200 448 384Q448 416 416 416L96 416Q64 416 64 384L64 200 256 328Z" />
                </svg>
              </div>
            </div>

            <!-- Address -->
            <div class="mt-[23px] flex contact-info max-sm:flex-col max-sm:items-center"
              :class="{ 'flex-row-reverse': $i18n.locale === 'ar' }">
              <div
                :class="[$i18n.locale === 'ar' ? 'ml-[18px]' : 'ml-[18px]', 'order-1', { 'order-none': $i18n.locale === 'ar' }, 'w-full']">
                <p class="font-Inter text-[14px] font-medium text-[#26c561] max-sm:text-center">{{ $t('footer.address')
                }}</p>
                <p class="font-Inter text-[12px] font-medium text-white max-sm:text-center">{{ $t('footer.addressLabel')
                }}</p>
              </div>
              <div class="flex h-[38px] w-[38px] items-center justify-center rounded-[75%] max-sm:mb-2"
                :class="{ 'order-1': $i18n.locale === 'ar' }">
                <svg fill="white" width="35" height="35" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M49,18.92A23.74,23.74,0,0,0,25.27,42.77c0,16.48,17,31.59,22.23,35.59a2.45,2.45,0,0,0,3.12,0c5.24-4.12,22.1-19.11,22.1-35.59A23.74,23.74,0,0,0,49,18.92Zm0,33.71a10,10,0,1,1,10-10A10,10,0,0,1,49,52.63Z" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Navigation & Download Section -->
          <div class="mt-6 flex w-full flex-col justify-between text-white sm:flex-row md:mt-0 md:max-w-[341px]">
            <!-- Pages Navigation -->
            <div class="max-sm:text-center" :class="{ 'text-right': $i18n.locale === 'ar' }">
              <p class="text-[#26c561] font-inter text-[18px] font-medium leading-normal">{{ $t('footer.pages') }}</p>
              <ul>
                <li v-for="(link, index) in navigation" :key="index" class="mt-[15px]">
                  <a class="text-deutziawhite hover:text-deutziawhite/80 font-inter text-[15px] font-normal hover:font-semibold"
                    :href="link.href">{{ $t(link.text) }}</a>
                </li>
              </ul>
            </div>

            <!-- Download Apps -->
            <div class="mt-6 flex flex-col gap-4 sm:mt-0 items-center">
              <p class="text-[#26c561] font-medium text-[18px]">{{ $t('footer.downloadApp') }}</p>
              <div class="flex gap-4 sm:flex-col">
                <!-- <a target="_blank" href="#">
                  <img :alt="$t('footer.playStore')" loading="lazy" width="168" height="50"
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/1280px-Google_Play_Store_badge_EN.svg.png" />
                </a> -->
                <a :href="apkFilePath" @click.prevent="downloadAPK"
                  class="flex items-center w-[110px] h-[50px]  text-white rounded-md  transition duration-300 overflow-hidden cursor-pointer">
                  <!-- Android Logo SVG -->
                  <svg class="w-8 h-8 ml-2" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6,18c0,0.55 0.45,1 1,1h1v3.5c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5L11,19h2v3.5c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5L16,19h1c0.55,0 1,-0.45 1,-1L18,8L6,8L6,18zM3.5,8C2.67,8 2,8.67 2,9.5v7c0,0.83 0.67,1.5 1.5,1.5S5,17.33 5,16.5v-7C5,8.67 4.33,8 3.5,8zM20.5,8c-0.83,0 -1.5,0.67 -1.5,1.5v7c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5v-7c0,-0.83 -0.67,-1.5 -1.5,-1.5zM15.53,2.16l1.3,-1.3c0.2,-0.2 0.2,-0.51 0,-0.71c-0.2,-0.2 -0.51,-0.2 -0.71,0l-1.48,1.48C13.85,1.23 12.95,1 12,1c-0.96,0 -1.86,0.23 -2.66,0.63L7.85,0.15c-0.2,-0.2 -0.51,-0.2 -0.71,0c-0.2,0.2 -0.2,0.51 0,0.71l1.31,1.31C6.97,3.26 6,5.01 6,7h12C18,5 17.03,3.25 15.53,2.16zM10,5L9,5L9,4h1L10,5zM15,5h-1L14,4h1L15,5z" />
                  </svg>
                  <div class="flex flex-col" :class="[$i18n.locale === 'ar' ? 'mr-1' : 'ml-1']"
                    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                    <span class="text-[10px] font-light leading-tight">{{ $t('footer.directDownload') }}</span>
                    <span class="text-[16px] font-bold leading-tight">{{ $t('footer.android') }}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr class="mt-[30px] text-white" />

        <!-- Copyright -->
        <div class="flex items-center justify-center pb-8 pt-[9px] md:py-8">
          <p class="text-[10px] font-normal text-white max-sm:text-center md:text-[12px]">
            {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {
      navigation: [
        { text: 'footer.nav.home', href: '#hero' },
        { text: 'footer.nav.about', href: '#about' },
        { text: 'footer.nav.pricing', href: '#pricing' },
        { text: 'footer.nav.contact', href: '#contact' }
      ],
      apkFileName: 'mts_gps_2.4.3.apk', // اسم ملف الـ APK الذي سيتم تنزيله
      apkFilePath: '/downloads/mts_gps_2.4.3.apk' // مسار ملف الـ APK على الخادم
    }
  },
  methods: {
    downloadAPK() {
      try {
        // إنشاء عنصر رابط للتنزيل
        const link = document.createElement('a');
        link.href = this.apkFilePath;
        link.setAttribute('download', this.apkFileName);

        // إضافة عنصر الرابط للصفحة
        document.body.appendChild(link);

        // النقر على الرابط لبدء التنزيل
        link.click();

        // إزالة عنصر الرابط من الصفحة بعد التنزيل
        document.body.removeChild(link);

        console.log('بدء تنزيل: ' + this.apkFileName);
      } catch (error) {
        console.error('حدث خطأ أثناء تنزيل الملف:', error);
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;900&display=swap');

[dir="ltr"] h1,
[dir="ltr"] h2,
[dir="ltr"] p,
[dir="ltr"] a {
  font-family: "Poppins", sans-serif;
}

[dir="rtl"] h1,
[dir="rtl"] h2,
[dir="rtl"] p,
[dir="rtl"] a {
  font-family: "Cairo", sans-serif;
}

.ltr {
  direction: ltr;
}
</style>